import React from 'react';
import GenericShipmentRequest from '../GenericShipmentRequest';

const AccountsShipmentRequest = () => (
  <GenericShipmentRequest
    sectionName="Accounts Section"
    sectionKey="Accounts"
    backRoute="/sections/accounts"
  />
);

export default AccountsShipmentRequest;
